/**
 * @file DataExtractors/TrendingClips/index.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */

import { page_initial_data } from "../../../Page/reducer";
import { setData } from "../../util";
import { hasVideoKeyInPayload } from "../../util";
import * as CONSTANTS from "../../../../actions/VideoTrending/constants";

export const initialState = setData();

export default function extractTrendingClips(action) {
    switch (action.type) {
        case page_initial_data.type:
            if (!hasVideoKeyInPayload(action.payload, "trendingClips"))
                return initialState;

            return setData(action.payload.video.data.trendingClips);

        case CONSTANTS.VIDEO_TRENDING_UPDATE:
            return setData(action.payload);

        case CONSTANTS.VIDEO_TRENDING_NULL:
            return initialState;

        case CONSTANTS.VIDEO_TRENDING_ERROR:
            return {
                items: [],
                isLoaded: true,
                errors: [action.payload],
            };

        default:
            return;
    }
}
